import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import store from './redux/store';
import ErrorBoundary from './components/Common/ErrorBoundary/ErrorBoundary';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
        // <React.StrictMode>
        <Provider store={store}>
                <BrowserRouter>
                        <ErrorBoundary>
                                <App />
                        </ErrorBoundary>
                </BrowserRouter>
        </Provider>,
        // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
